// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"da9220c1","109":"f2540f14","197":"2d871ec3","383":"f99fc728","402":"9e1095ae","611":"547f8c05","623":"c969483e","631":"c4b7643e","894":"aa5e5689"}[chunkId] + ".chunk.js";
};